import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { useInsiderFeatureEligibility } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderFeatureEligibility";
import { Container, ContentWrapper, TextSkeleton } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderHowToUse/__internal__/InsiderHowToUseCardAssets/styled";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { HorizontalLine, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var CheckoutBenefits = function() {
    var hasFreeDutyAdvertising = useInsiderFeatureEligibility().hasFreeDutyAdvertising;
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsx(ContentWrapper, {
            children: /*#__PURE__*/ _jsxs(Card, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        align: "center",
                        variant: "sectionHeaderSansMedium",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "dPrfQK",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Review your order"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Row, {
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ _jsx(TextSkeleton, {
                                margin: getSpacing(20, 0, 12),
                                width: "170px",
                                stroke: "17px"
                            }),
                            /*#__PURE__*/ _jsx(TextSkeleton, {
                                margin: getSpacing(20, 0, 12),
                                width: "44px",
                                stroke: "17px"
                            })
                        ]
                    }),
                    hasFreeDutyAdvertising ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "1x"
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ _jsx(Row, {
                                        children: /*#__PURE__*/ _jsx(Typography, {
                                            color: Decorative.icon.teal,
                                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                id: "Q3wEI5",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "Insider import duties"
                                                    }
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        color: Decorative.icon.teal,
                                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                            id: "3LnTAU",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "Free"
                                                }
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsx(HorizontalLine, {
                        color: Core.border.muted,
                        margin: getSpacing(18, 0),
                        width: "100%"
                    }),
                    /*#__PURE__*/ _jsx(TextSkeleton, {
                        width: "100%",
                        stroke: "17px"
                    }),
                    /*#__PURE__*/ _jsx(TextSkeleton, {
                        margin: getSpacing(10, 0, 17),
                        width: "197px",
                        stroke: "17px"
                    }),
                    /*#__PURE__*/ _jsx(ImageGrid, {})
                ]
            })
        })
    });
};
var Card = styled.div.withConfig({
    componentId: "sc-8227ae37-0"
})([
    "width:388px;height:347px;padding:",
    ";background-color:",
    ";"
], getSpacing(30, 38), Core.surface.inverse);
var ImageGrid = function() {
    var isSSR = useIsSSR();
    var FIRST_PRODUCT_IMAGE = optimizeImageUrl({
        url: "https://cdn.faire.com/fastly/2c65191285a9339792e6d082b6bdc8c7e1a10b333eb95011caea643a416ddf82.png"
    }, isSSR, {
        width: 56,
        height: 56
    });
    var SECOND_PRODUCT_IMAGE = optimizeImageUrl({
        url: "https://cdn.faire.com/fastly/9a428943433cc83d01e8d133e1e1b8a54b2bba22a39262ef182a65edffa9f7ce.png"
    }, isSSR, {
        width: 56,
        height: 56
    });
    var THIRD_PRODUCT_IMAGE = optimizeImageUrl({
        url: "https://cdn.faire.com/fastly/5a6f6249aec7f19b24a2bf3db9c37940aa17d4cd7b6209bff41325e48405a709.png"
    }, isSSR, {
        width: 56,
        height: 56
    });
    return /*#__PURE__*/ _jsxs(Row, {
        children: [
            /*#__PURE__*/ _jsx(Image, {
                src: FIRST_PRODUCT_IMAGE
            }),
            /*#__PURE__*/ _jsx(Image, {
                src: SECOND_PRODUCT_IMAGE
            }),
            /*#__PURE__*/ _jsx(Image, {
                src: THIRD_PRODUCT_IMAGE
            })
        ]
    });
};
var Image = styled.img.withConfig({
    componentId: "sc-8227ae37-1"
})([
    "width:56px;height:56px;& + &{margin:",
    ";}"
], getSpacing(0, 0, 0, "1x"));
